import { apiCall, ApiConfig } from '../../config/api'
import { Zone } from '../../interfaces/Zone/Zone'
import { getZonesAction } from '../actions/zoneActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_ZONES } from '../types/zoneActionsTypes'
import { DataGridElements } from '../../interfaces/index'

export function* getZonesAsync() {
  try {
    const { status, data }: AxiosResponse<DataGridElements<Zone>> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.ZoneApi}?pageSize=100`
    )
    if (status === 200) {
      yield put(getZonesAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getZonesAction([], serverError.message))
  }
}

export function* watchGetZonesAsync() {
  yield takeEvery(GET_ZONES, getZonesAsync)
}
